import {
    AccreditationsSlotId,
    DelegationAccreditationSlotFragment,
    FormAccreditationsOptionsFragment,
    FormAccreditationsQuery,
    VolunteersRegistrationsSlotInput
} from 'common/src/generated/types';
import { canSelect } from 'common/src/vo/accreditation';
import { Fields } from 'common/src/vo/field';
import { sortBy } from 'lodash-es';
import * as React from 'react';
import { AccreditationCategory } from '../../../accreditations/v2/accreditationCategory';
import { FormAccreditationsSlotsAccreditation } from './formAccreditationsSlotsAccreditation';

interface IFormAccreditationsSlotsCategoryProps {
    accreditationsSlotsIds: AccreditationsSlotId[];
    category: FormAccreditationsQuery['event']['accreditationsCategories'][0];
    delegationAccreditations: DelegationAccreditationSlotFragment[];
    displayFormCustomFields: boolean;
    options: FormAccreditationsOptionsFragment;
    prefix: string;
    slots: VolunteersRegistrationsSlotInput[];
    userInfoFields: Fields;

    change(name: string, value: any): void;
}

export const FormAccreditationsSlotsCategory = (props: IFormAccreditationsSlotsCategoryProps) => {
    const accreditations = React.useMemo(
        () =>
            sortBy(
                props.category.accreditations.filter((accreditation) =>
                    canSelect(
                        accreditation,
                        props.slots,
                        props.userInfoFields,
                        props.options,
                        props.delegationAccreditations
                    )
                ),
                (a) => a.name.toLowerCase()
            ),
        [
            props.category,
            props.delegationAccreditations,
            props.slots,
            props.userInfoFields,
            props.options
        ]
    );

    return (
        <AccreditationCategory category={props.category}>
            {accreditations.map((accreditation) => (
                <FormAccreditationsSlotsAccreditation
                    key={accreditation.id}
                    accreditation={accreditation}
                    accreditationsSlotsIds={props.accreditationsSlotsIds}
                    change={props.change}
                    delegationAccreditations={props.delegationAccreditations}
                    displayFormCustomFields={props.displayFormCustomFields}
                    options={props.options}
                    prefix={props.prefix}
                    slots={props.slots}
                />
            ))}
        </AccreditationCategory>
    );
};
